export default class Settings
{
  constructor(email, phone, facebook, address, latitude, longitude) 
  {
    this.email = email;
    this.phone = phone;
    this.facebook = facebook;
    this.address = address;
    this.latitude = latitude;
    this.longitude = longitude;
  }    

  isValid()
  {
    return this.email && this.phone && this.facebook && this.address && this.latitude && this.longitude;
  }
}